// extracted by mini-css-extract-plugin
export default {"percent":"glass-fill_percent__PlfVA","glass_svg":"glass-fill_glass_svg__zxXt2","masked_area":"glass-fill_masked_area__-hz6P"};